export const STUDENT_PRIVACY_STORAGE_KEY = "teachleague_blur_student_names";

const MASK_CHARACTER = "*";

const maskNameToken = (token) => {
  const trimmedToken = String(token || "").trim();
  if (!trimmedToken) return "";

  const [firstCharacter, ...restCharacters] = trimmedToken;
  if (!firstCharacter) return "";
  if (restCharacters.length === 0) return `${firstCharacter}${MASK_CHARACTER}`;

  return `${firstCharacter}${MASK_CHARACTER.repeat(restCharacters.length)}`;
};

export const readStudentPrivacyPreference = () => {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STUDENT_PRIVACY_STORAGE_KEY) === "1";
  } catch (error) {
    return false;
  }
};

export const maskStudentName = (name, fallback = "Student") => {
  const normalized = String(name || "").trim();
  const source = normalized || fallback;
  return source
    .split(/\s+/)
    .map((token) => maskNameToken(token))
    .join(" ");
};

export const formatStudentName = (name, blurStudentNames, fallback = "Student") => {
  if (blurStudentNames) {
    return maskStudentName(name, fallback);
  }
  const normalized = String(name || "").trim();
  return normalized || fallback;
};

export const formatStudentNameList = (names = [], blurStudentNames) => {
  if (!Array.isArray(names)) return [];
  return names
    .map((name) => formatStudentName(name, blurStudentNames))
    .filter(Boolean);
};
